var exports = {
  "qS": "MentionBadge.module__badge___VnYyZG",
  "ZN": "MentionBadge.module__badgeSmall___VnYyZG",
  "N1": "MentionBadge.module__badgeMedium___VnYyZG",
  "x5": "MentionBadge.module__animatedWrapper___VnYyZG",
};

module.exports = exports;
